import { Injectable, Inject } from '@angular/core';
import { StorageService } from './storage.service';
import { HttpHeaders, HttpClient, HttpHeaderResponse } from '@angular/common/http';

@Injectable()
export class BillingService {

    constructor(private storageService: StorageService,
        private http: HttpClient,
        @Inject('API_BASE_URL') private baseUrl: string) {

    }

    private firstQueryString: boolean = false;

    getSummary(clientId: number, siteId?: number): Promise<any> {
        let url = this.baseUrl + 'Billing/summary/' + clientId;

        this.firstQueryString = true;

        if (siteId && siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));

        let promise = new Promise<any>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "could not get billing summary data"
                    });
                });
        });

        return promise;
    }


    getAccountBalance(clientId: number, siteId?: number, timePeriod?: number): Promise<any[]> {
        let url = this.baseUrl + 'Billing/cumulativeaccountbalance/' + clientId;

        this.firstQueryString = true;

        if (siteId && siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (timePeriod && timePeriod > 0) url = url.concat(this.createQueryStringParameter('timePeriod', timePeriod.toString()));

        let promise = new Promise<any[]>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any[]);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "could not get billing cumlative account data"
                    });
                });
        });

        return promise;
    }

    getPaymentsByType(clientId: number, siteId?: number, timePeriod?: number): Promise<any[]> {
        let url = this.baseUrl + 'Billing/paymentsByType/' + clientId;

        this.firstQueryString = true;

        if (siteId && siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (timePeriod && timePeriod > 0) url = url.concat(this.createQueryStringParameter('timePeriod', timePeriod.toString()));

        let promise = new Promise<any[]>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any[]);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "could not get billing payments by type data"
                    });
                });
        });

        return promise;
    }

    getAgedDebt(clientId: number, siteId?: number, timePeriod?: number): Promise<any[]> {
        let url = this.baseUrl + 'Billing/ageddebt/' + clientId;

        this.firstQueryString = true;

        if (siteId && siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (timePeriod && timePeriod > 0) url = url.concat(this.createQueryStringParameter('timePeriod', timePeriod.toString()));

        let promise = new Promise<any[]>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any[]);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "could not get billing aged debt data"
                    });
                });
        });

        return promise;
    }

    getBillHistory(clientId: number, siteId?: number, timePeriod?: number): Promise<any[]> {
        let url = this.baseUrl + 'Billing/billhistory/' + clientId;

        this.firstQueryString = true;

        if (siteId && siteId > 0) url = url.concat(this.createQueryStringParameter('siteId', siteId.toString()));
        if (timePeriod && timePeriod > 0) url = url.concat(this.createQueryStringParameter('timePeriod', timePeriod.toString()));

        let promise = new Promise<any[]>((resolve, reject) => {
            this.http.get(url)
                .toPromise()
                .then(res => {
                    var data = (res as any[]);
                    resolve(data);
                })
                .catch(reason => {
                    reject({
                        status: reason.status,
                        description: "could not get billing history data"
                    });
                });
        });

        return promise;
    }

    private createQueryStringParameter(key: string, value: string) {
        var val = this.firstQueryString ? "?" : "&";
        this.firstQueryString = false;
        return val.concat(key).concat("=".concat(value));
    }


}
